<template>
  <el-checkbox
    :model-value="props.modelValue"
    :disabled="props.disabled"
    :indeterminate="props.indeterminate"
    @change="(value) => emit('update:modelValue', value)"
  >
    <span v-html="sanitize(props.label)" />
    <div
      v-if="props.description"
      class="text-gray-500"
      v-html="sanitize(props.description)"
    />
  </el-checkbox>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  indeterminate: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);
</script>
